import clsx from "clsx";
import React from "react";

const Loading = ({ pageOnLoader = false }) => {
  return (
    <div
      className={clsx(
        "fixed inset-0  flex items-center justify-center",
        pageOnLoader
          ? " z-[99999] backdrop-blur-sm"
          : "z-50 bg-white bg-opacity-80 backdrop-blur-md"
      )}
    >
      <div className="h-12 w-12 animate-spin rounded-full border-4 border-gray-300 border-t-blue-500"></div>
    </div>
  );
};

export default Loading;
